// src/App.js
import React from 'react';
import Formulario from './components/Formulario/Formulario.js';
import "./app.css"

function App() {
  return (
    <div className='first-div'>
      <Formulario />
    </div>
  );
}

export default App;
